<script setup>
import {ref, onMounted, watch, computed, getCurrentInstance, toRaw, onBeforeUnmount, inject, defineExpose} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from '../../../../../layouts/nav/SNB.vue'
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";
import _ from "lodash";
import KSASecondaryButton from "@/components/ui-components/button/KSASecondaryButton.vue";

const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()

const ojfId = ref(route.query.ojfId || '');

onMounted(()=>{
  if(!ojfId) {
    router.push({name: 'MatchingJobFairList'})
  } else {
    // loadingStore.loading = true;
    ojfIntvDay();

    _.each(intvDays.value, el => {el.on = false;})
  }
})

const intvDays = ref([]); // 면접 가능일
const isAllActive = ref(false); // 면접일 전체
const isEtcActive = ref(false); // 면접일 외 일정

const createEntry = ref({
  "joinPurpose": "",
  "intvInYn": "",
  "intvAbleDay": "",
  "agreePrivacyYn": false,
})

const inputError = ref({
  joinPurpose: "", // 참가목적
  intvAbleDay: "", // 면접일
  agreePrivacyYn: false // 동의
})

// 모달
const modal = ref(null)
const confirmModal = ref(null)
const modalContent = ref([]);
const okButtonText = ref("확인");
const cancelButtonText = ref("취소");

// 면접 가능일 조회
const ojfIntvDay = () => {
  loadingStore.loading = true;
  jobFairUserService.ojfIntvDay(ojfId.value)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          if (result !== null && result !== '') {
            const selectedDays = result.split(',').map(d => d.trim());

            intvDays.value = selectedDays.map(day => ({
              label: day,
              on: false
            }));
          }
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 면접 가능일 클릭
const onClickIntvDay = (clickedDay) => {
  inputError.value.intvAbleDay = '';
  isEtcActive.value = false
  createEntry.value.intvInYn = 'Y';

  if (isAllActive.value) {
    // 전체 모드 해제 → 클릭한 날짜만 on
    isAllActive.value = false

    intvDays.value.forEach(day => {
      day.on = (day === clickedDay)
    })
  } else {
    // 전체 상태가 아닐 때는 토글만
    clickedDay.on = !clickedDay.on

    // 날짜 전체가 선택되었는지 확인
    const allSelected = intvDays.value.every(day => day.on)
    isAllActive.value = allSelected
  }
}

// 면접 가능일 전체
const onClickAll = () => {
  inputError.value.intvAbleDay = ''

  if (isAllActive.value) {
    isAllActive.value = false
    isEtcActive.value = false
    createEntry.value.intvInYn = '';

    intvDays.value.forEach(day => {
      day.on = false
    })
  } else {
    isAllActive.value = true
    isEtcActive.value = false
    createEntry.value.intvInYn = 'Y';

    intvDays.value.forEach(day => {
      day.on = true
    })
  }
}

// 면접 가능일 외
const onClickEtc = () => {
  inputError.value.intvAbleDay = ''

  if (isEtcActive.value) {
    isEtcActive.value = false
    createEntry.value.intvInYn = 'Y'
  } else {
    isEtcActive.value = true
    isAllActive.value = false
    createEntry.value.intvInYn = 'N'

    intvDays.value.forEach(day => {
      day.on = false
    })
  }
}

// 면접 가능일 외
// const onClickEtc = () => {
//   inputError.value.intvAbleDay = ''
//   isEtcActive.value = true
//   isAllActive.value = false
//   createEntry.value.intvInYn = 'N';
//
//   intvDays.value.forEach(day => {
//     day.on = false
//   })
// }

// 참가 신청 등록
const saveEntry = async () => {
  let isInvalid = false;

  // 참가 목적
  const { joinPurpose } = createEntry.value;
  inputError.value.joinPurpose = '';

  // 면접 가능일
  const intvAbleDay = _.map(_.filter(intvDays.value, {'on': true}), 'label').join(',');
  const { intvInYn } = createEntry.value;
  inputError.value.intvAbleDay = '';

  // 약관 동의
  const agreePrivacyYn = createEntry.value.agreePrivacyYn ? 'Y' : 'N';
  inputError.value.agreePrivacyYn  = false;

  // ella : 참가 목적 숨김 요청 (20250904)
  // if(!joinPurpose) {
  //   inputError.value.joinPurpose = '참가 목적을 입력하세요.';
  //   isInvalid = true;
  // }

  if(!intvInYn) {
    inputError.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  } else if (intvInYn === 'Y' && !intvAbleDay) {
    inputError.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  }

  if (isInvalid) {
    modalContent.value = ["필수 입력사항을 확인해 주세요."];
    modal.value.show();
    isInvalid = true;
  } else if(agreePrivacyYn === 'N') {
    modalContent.value = ["필수 약관을 확인하고 동의해 주세요."];
    modal.value.show();
    isInvalid = true;
  }

  // 저장 처리
  if(!isInvalid) {

    modalContent.value = ["참가 신청을 위해서는 인재정보에 공개할", "이력서 등록이 필요합니다.", "등록된 이력서는 추후 언제든 수정이 가능하며,", "공개 설정 변경도 가능합니다."];
    okButtonText.value = "이력서 등록하기";
    cancelButtonText.value = "참가 신청 취소";

    const ok = await confirmModal.value.show();
    if(!ok) {
      // return -1;
      modalContent.value = ["참가 신청이 취소되었습니다."];
      await modal.value.show();

      router.push({name: 'MatchingJobFairDetail', params:{id: ojfId.value}})
    } else {
      // 참가신청 정보 세션에 저장
      const entryData = {
        ojfId: ojfId.value,
        joinPurpose,
        intvInYn,
        intvAbleDay,
        agreePrivacyYn
      };
      sessionStorage.setItem('entryData', JSON.stringify(entryData));

      router.push({ name: 'MyPageJobFairResumeCreate', query : { ojfId: ojfId.value, mode : 'entry' }});
    }
  }
}


const clickCancel = async (ojfId) => {
  modalContent.value = ["참가 신청이 취소되었습니다."];
  await modal.value.show();

  router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}})
}

// 특수문자 작성 안됨
const filterText = (value) => {
  return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
}

const onInputChange = (event, key) => {
  createEntry.value[key] = filterText(event.target.value); // 필터링된 값 적용
  inputError.value.joinPurpose = '' ? '참가 목적을 입력하세요.' : ''
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <!-- S : 강의 상세-->
        <div class="content">
          <div class="lecture-wrap">
            <div class="sub-title grid space-between">
              <h3>참가 신청</h3>
            </div>
            <p class="mt-xs">특별채용관 참가를 위한 신청서를 작성하세요.(<span class="red">*</span>표시는 필 수 입력사항입니다.)</p>
            <div class="lecture-detail">
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">참가 신청 정보</th>
                  </tr>
                  <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--                  <tr>-->
<!--                    <th class="mark">참가 목적</th>-->
<!--                    <td>-->
<!--                      <KSAInput v-model="createEntry.joinPurpose" @input="(event) => onInputChange(event, 'joinPurpose')" placeholder="ex) 취업 기회 탐색, 채용  정보 획득, 기업의 인사 담당자 또는 채용 관계자와의 네트워킹 등" />-->
<!--                      <p>-->
<!--                        <small style="color:#E71414;">{{ inputError.joinPurpose }}</small>-->
<!--                      </p>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr>
                    <th rowspan="2">
                      <span class="mark">면접 가능일</span>
                    </th>
                    <td>
                      <ul class="grid category-wrap">
                        <li :class="{'active': isAllActive}" @click="onClickAll">전체 일정 가능</li>
                        <li :class="{'active': day.on, 'disabled': isAllActive}" v-for="day in intvDays" @click="onClickIntvDay(day)">
                          {{ day.label }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul class="grid category-wrap">
                        <li :class="{'active': isEtcActive}" @click="onClickEtc">면접 일정 조율</li>
                      </ul>
                      <p>
                        <small style="color:#E71414;">{{ inputError.intvAbleDay }}</small>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- s: 약관 동의 -->
              <div class="terms-wrap">
                <hr>
                <KSACheckBox label="개인정보의 수집 · 이용 · 제공 및 활용에 동의합니다." v-model="createEntry.agreePrivacyYn" /><span class="red">(필수)</span>
                <div class="terms-box">
                  1. 수집하는 개인정보 항목<br>
                  회사는 회사가 주최 및 주관하는 특별채용관의 참가 신청, 채용 입사 지원을 위한 개인정보 확인 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br><br>

                  - 이름, 핸드폰 번호, 이메일, 거주지역, 학력, 학교, 전공, 성적증명서, 포트폴리오(수상작, 논문, 프로젝트 결과물 등), 자격증 및 외국어 능력, 업무 경험(경력 정보), 병역 유무 등<br><br>

                  2. 정보의 이용 목적 및 제공 범위<br>
                  회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br><br>

                  - 회원 관리 회원제 서비스 이용에 따른 본인 확인, 개인 식별, 특별채용관 참가 의사 확인, 문의사항 처리 및 공지사항 전달<br>
                  - 특별채용관 채용 공고 확인 및 입사 지원을 위한 개인 이력 정보 제공 목적<br>
                  - 특별채용관 참가 기업 회원들에게 제공되는 개인 이력 정보 노출을 위한 목적<br><br>

                  3. 정보 보유 및 이용기간<br>
                  회사는 수집한 개인정보를 이용목적이 달성된 후에는 회원탈퇴 시까지 보유하고 회원탈퇴 이후에는 해당 정보를 지체 없이 파기합니다.
                </div>
              </div>
              <!-- e: 약관 동의-->
            </div>
            <div class="btn-wrap space-between">
              <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel(ojfId)" />
              <KSAPrimaryButton text="다음" @click="saveEntry()" />
            </div>
          </div>
        </div>
        <!-- E : 강의 상세-->
      </div>
    </div>
  </div>
  <AlertModal ref="modal" :content="modalContent" />
  <ConfirmModal ref="confirmModal" :content="modalContent" :okButtonText="okButtonText" :cancelButtonText="cancelButtonText" />
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          small {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
  .disabled {
    cursor: default;
    background: $gray-regular_color;
    border-color: $gray-regular_color;
    color: #fff;
  }
}

.terms-wrap {
  margin: 20px 0;

  > .check-box:first-child {
    @include font-size_md;
  }

  hr {
    border: $border_line;
    margin: 20px 0;
  }

  .terms-box {
    height: 180px;
    overflow-y: auto;
    @include font-size_xs;
    background: $gray-thin_color;
    border: $border_line;
    padding: 20px;
    margin: 10px 0 40px;
  }
}
</style>